import type { Option } from '@zen/DesignSystem/types';
import type { Nullable } from '@zen/utils/typescript';

import TerminalsAndGroupsSelect, { type TerminalOrGroup } from '../../TerminalsAndGroupsSelect';
import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';
import FormSelect from '../FormSelect';
import type { FormInstance } from '../types';

interface Props<T = TerminalOrGroup> extends FormFieldProps {
  includeGroups?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  predefinedOptions?: Option<T>[];
  renderMenuInPortal?: boolean;
}

const FormTerminalsAndGroupsSelect = <T extends Nullable<{}> = TerminalOrGroup>(props: Props<T>) => {
  const { predefinedOptions, ...fieldProps } = props;

  if (predefinedOptions?.length) {
    const { includeGroups, ...formSelectProps } = fieldProps;

    return <FormSelect {...formSelectProps} options={predefinedOptions} />;
  }

  const { label, ...rest } = fieldProps;

  return (
    <FormField {...fieldProps}>
      {(
        field: { error: boolean; label: string; name: string; value: Nullable<TerminalOrGroup> },
        form: FormInstance<unknown>
      ) => {
        const { label: fieldLabel, ...fieldRest } = field;

        return (
          <TerminalsAndGroupsSelect
            {...rest}
            {...fieldRest}
            hasError={field.error}
            onChange={(value: Nullable<TerminalOrGroup>) => {
              form.setFieldValue(field.name, value);
            }}
          />
        );
      }}
    </FormField>
  );
};

export type { Props as FormTerminalsAndGroupsSelectProps };

export default FormTerminalsAndGroupsSelect;
